module.exports = __webpack_public_path__ + "img/40_38_031_130.1830e45b.jpg";